import { mesaColorNames, typography } from '@/src/common/theme'
import { Text, TouchableOpacity } from 'react-native'

export function Chip({
  label,
  selected,
  onPress,
  containerStyle = {},
}: {
  label: string
  selected?: boolean
  onPress: () => void
  containerStyle?: React.ComponentProps<typeof TouchableOpacity>['style']
}) {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        {
          backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
          borderRadius: 20,
          borderWidth: 1,
          borderColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
          paddingHorizontal: 16,
          marginRight: 8,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          minHeight: 30,
          justifyContent: 'center',
        },
        selected && {
          backgroundColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
        },
        containerStyle,
      ]}
    >
      <Text
        style={[
          typography['label/xs-bold'],
          selected && { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] },
        ]}
      >
        {label}
      </Text>
    </TouchableOpacity>
  )
}
